import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

import {Linear, TimelineLite, TweenLite} from "gsap";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {SoundManager} from "../sound/SoundManager";
import {TOATimelineReelsController} from "../reel/TOATimelineReelsController";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class TombOfAkhenatenFreeSpinIntroView extends StandardAutoCloseGameModeTransitionView {

    private _compCallback: () => void;
    private _fsContent: PIXI.Container;
    private _fsZoomInSpine: PIXI.spine.Spine;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    private _fsWonText: PIXI.Text;
    private _fsContainer: PIXI.Container;
    private _scrollBurnLeftAnimation: PIXI.spine.Spine;
    private _scrollBurnRightAnimation: PIXI.spine.Spine;
    private _fireBurnAnimation: PIXI.spine.Spine;

    private _treasureText: PIXI.Text;
    private _fsIntroRestored: boolean = false;

    private _hidingLayers: string[] = [];

    constructor(layer: ScalableLayer) {
        super(layer);
    }

    public prepare(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
        this._fsIntroRestored = (data as TombOfAkhenatenParsedInitData).isRestoreState ? (data as TombOfAkhenatenParsedInitData).isRestoreState : false;
        super.prepare(data);
    }

    public startTimerAndEnableButton(callback: () => void) {
        this._compCallback = callback;
        this._button.enabled = false;
        this._button.visible = false;
    }

    public getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        this._layer.addChild(this);
        this.resetGraphics();
        this.startTimerAndEnableButton(completeCallback);

        const tl = new TimelineLite();

        tl.add(() => {
            TweenLite.to(this._mainGraphicsContainer, 0.5, {
                alpha: 1,
                ease: Linear.easeNone
            });
        }, 0);

        tl.add(() => {
            for (let i: number = 0; i < this._hidingLayers.length; i++) {
                let currlayer = StageManager.getLayer(this._hidingLayers[i]);

                TweenLite.fromTo(currlayer, 0.5, {
                    alpha: 1
                }, {
                    alpha: 0,
                    delay: (i === (this._hidingLayers.length - 1)) ? 0.25 : 0, // hiding pulley after delay
                    ease: Linear.easeNone
                });
            }
            SoundManager.playFSIntroSound();
        }, this._fsIntroRestored ? 0.01 : 0.5);

        tl.add(() => {
            this._scrollBurnLeftAnimation.updateTransform();
            this._scrollBurnLeftAnimation.visible = true;
            this._scrollBurnRightAnimation.updateTransform();
            this._scrollBurnRightAnimation.visible = true;
            TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN = this._gameData.activeRowsNextSpin || 3;
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_REEL_POSITIONS));
            (TombOfAkhenaten.timelineReelsController as TOATimelineReelsController).setFakeReel();
            this._fsWonText.alpha = 1;
            TweenLite.fromTo(this._fsContainer, 0.75, {
                alpha: 0
            }, {
                alpha: 1,
                ease: Linear.easeNone,
                onComplete: () => {
                    this._fsZoomInSpine.updateTransform();
                    this._fsZoomInSpine.visible = true;
                    this._button.enabled = true;
                    this._button.visible = true;
                    prepareToEnterModeCallback();
                }
            });
        }, this._fsIntroRestored ? 0.02 : 0.75);
        //return super.getStartAnimation(prepareToEnterModeCallback, completeCallback);
        return tl;
    }

    getEndAnimation(): TimelineLite {
        let _this = this;
        let tl: TimelineLite = new TimelineLite(),
            textDisplayed: boolean = (!(_this._fsIntroRestored) && TombOfAkhenatenGameConfig.instance.GAME_RESTORED);

        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.REMOVE_SCATTER_ANIMS));
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.REMOVE_WILD_LANDING_ANIMS));
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.STOP_SHAKE));
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.HIDE_ALL_PYRAMID));
        }, 0);

        tl.add(() => {
            for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
                TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(i, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin!);
            }
        }, textDisplayed ? tl.totalDuration() + 0.01 : (tl.totalDuration() + 0.5));

        //TODO reduce timing
        tl.add(() => {
            TweenLite.to(this._treasureText, 1, {alpha: 0});
        }, textDisplayed ? tl.totalDuration() + 0.1 : (tl.totalDuration() + 0.7));

        // tl.add(() => {
        //     //this._treasureText.visible = false;
        // }, textDisplayed ? tl.totalDuration() + 0.1 : (tl.totalDuration() + 1.5));

        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0.5, {alpha: 0, ease: Linear.easeNone}),
            this._fullScreenFade.getFadeOut(1)
        ]);
        tl.add(function () {
            _this._layer.removeChild(_this);
        });
        return tl;
    }

    protected createButton(): NineSliceButton {
        const text: string = Translation.translate("CONTINUE");
        const textStyle: TextStyleOptions = this.getButtonTextStyle();
        this._button = new NineSliceButton(() => this.onFSContinueClick(), ` ${text} `, textStyle);
        this._button.enabled = false;
        this._button.visible = false;
        return this._button;
    }

    protected onResize(data: IResizeData): void {
        super.onResize(data);
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._fsContent.position.set(this._screenRect.width * 0.5, this._screenRect.height * 0.5);
    }

    protected createBackground(): PIXI.DisplayObject {
        return new PIXI.Container();
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        let layerConfig = TombOfAkhenatenGameConfig.instance.LAYERS;
        this._hidingLayers = [layerConfig.OVERLAY_SPINES.name, layerConfig.FIRE_OVERLAY.name, layerConfig.REEL_BACKGROUND.name, layerConfig.SYMBOLS.name, layerConfig.REELS_FRAME.name, layerConfig.STONE_PRESSER.name, layerConfig.REEL_FOREGROUND.name, layerConfig.REEL_DIVIDERS.name];

        this._autoCloseTimer.visible = false;

        this._fsContainer = new PIXI.Container();
        this._fsContainer.alpha = 0;
        this._fsContainer.position.set(0, -50);

        this._fsContent = new PIXI.Container();
        this._fsContent.name = "_fsContent";

        this._fsWonText = new PIXI.Text("0", TombOfAkhenatenTextStyles.TOA_NUM_FONT);
        this._fsWonText.anchor.set(0.5);
        this._fsWonText.position.set(-230, 160);
        this._fsWonText.alpha = 0;

        this._fsZoomInSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fsZoomInSpine"));
        this._fsZoomInSpine.position.set(4, 0);
        this._fsZoomInSpine.scale.set(0.1855);
        this._fsZoomInSpine.visible = false;

        this._scrollBurnLeftAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("scrollBurnLeftSpine"));
        this._scrollBurnLeftAnimation.position.set(0.5, TombOfAkhenatenGameConfig.instance.JACKPOT_HEIGHT / 2);
        this._scrollBurnLeftAnimation.visible = false;
        this._scrollBurnRightAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("scrollBurnRightSpine"));
        this._scrollBurnRightAnimation.position.set(-0.5, TombOfAkhenatenGameConfig.instance.JACKPOT_HEIGHT / 2);
        this._scrollBurnRightAnimation.visible = false;
        this._fireBurnAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("fireBurnSpine"));
        this._fireBurnAnimation.position.set(0, TombOfAkhenatenGameConfig.instance.JACKPOT_HEIGHT / 2);
        this._fireBurnAnimation.visible = false;

        this._treasureText = new PIXI.Text(Translation.translate("Claim the treasure!"), TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        //this._treasureText.visible = false;
        this._treasureText.alpha = 0;
        if ((this._treasureText.width > TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.9)) {
            this.fitTreasureText();
        }

        this._treasureText.anchor.set(0.5);
        this._treasureText.position.set(0, 0);

        this._fsContainer.addChild(this._treasureText, this._scrollBurnLeftAnimation, this._scrollBurnRightAnimation, this._fireBurnAnimation, this._fsWonText);
        this._fsContent.addChild(this._fsZoomInSpine, this._fsContainer);
        return this._fsContent;
    }

    private fitTreasureText(): void {
        let scaleValue: number = ((TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.9) / this._treasureText.width);
        this._treasureText.scale.set(scaleValue);
    }

    private getButtonTextStyle(): TextStyleOptions {
        const style: TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if (typeof style.fontSize !== 'number') {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }

    private onFSContinueClick() {
        this._button.enabled = false;
        this._button.visible = false;

        SoundManager.playFSContinueBtnSound();
        SoundManager.playBonusGameStartSound();
        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            SoundManager.playBonusBgSound();
            this._fireBurnAnimation.alpha = 0;
            this._fireBurnAnimation.updateTransform();
            this._fireBurnAnimation.visible = true;
            TweenLite.to(this._fireBurnAnimation, 0.01, {alpha: 1});
            new SpineTween(this._scrollBurnLeftAnimation, 0, "burn_animation", 0);
            new SpineTween(this._scrollBurnRightAnimation, 0, "burn_animation", 0);
            new SpineTween(this._fireBurnAnimation, 0, "burn_animation", 0);
            TweenLite.fromTo(this._fsWonText, 0.1, {alpha: 1}, {alpha: 0, delay: 0.5});
        }, 0);
        tl.add(() => {
            new SpineTween(this._fsZoomInSpine, 0, "zoomInAnimation", 0);
        }, 0.85); //0.85 total time for _fireBurnAnimation

        tl.add(() => {
            for (let i: number = 0; i < TombOfAkhenatenGameConfig.instance.REELS_NUM; i++) {
                TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(i, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin!);
            }
        });

        tl.add(() => {
            //this._treasureText.visible = true;
            this._treasureText.alpha = 0;
            const scale = this._treasureText.scale.x;
            this._treasureText.scale.set(0);
            TweenLite.to(this._treasureText, 0.7, {
                alpha: 1, onComplete: () => {
                    TweenLite.to(this._treasureText.scale, 1.4, {x: scale, y: scale});
                }
            });
        });
        tl.add(() => {
            if (this._compCallback) {
                this.stopTimerAndDisableButton();

                for (let i: number = 0; i < this._hidingLayers.length; i++) {
                    let currlayer = StageManager.getLayer(this._hidingLayers[i]);

                    TweenLite.fromTo(currlayer, 0.01, {
                        alpha: 0
                    }, {
                        alpha: 1,
                        ease: Linear.easeNone,
                        onComplete: () => {
                            TweenLite.to(this._fsZoomInSpine, 0.5, {alpha: 0, onComplete: () => {
                                this._fsZoomInSpine.visible = false;
                                this._fsZoomInSpine.alpha = 1;
                            }});
                        }
                    });
                }
                this._compCallback();
            }
        }, 2.1);
        tl.play(0);
    }

    private resetGraphics(): void {
        let fsCount: number = this._gameData.freespinsLeft;
        this._fsWonText.text = (fsCount).toString();
        this._fsWonText.alpha = 0;

        if (fsCount < 10) {
            this._fsWonText.scale.set(1);
            this._fsWonText.position.set(-220, 160);
        } else {
            this._fsWonText.scale.set(0.8);
            this._fsWonText.position.set(-235, 163);
        }

        this._fsZoomInSpine.skeleton.setToSetupPose();
        this._fsZoomInSpine.state.tracks = [];

        this._scrollBurnLeftAnimation.skeleton.setToSetupPose();
        this._scrollBurnLeftAnimation.state.tracks = [];
        this._scrollBurnLeftAnimation.visible = false;

        this._scrollBurnRightAnimation.skeleton.setToSetupPose();
        this._scrollBurnRightAnimation.state.tracks = [];
        this._scrollBurnRightAnimation.visible = false;
    }
}